import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=896c6f98&scoped=true&"
import script from "./AddAgent.vue?vue&type=script&lang=js&"
export * from "./AddAgent.vue?vue&type=script&lang=js&"
import style0 from "./AddAgent.vue?vue&type=style&index=0&id=896c6f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c6f98",
  null
  
)

export default component.exports